<div class="row">
    <div class="col-lg-7">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-buttons
                        [grid]="grid"
                        [canEdit]="canEdit"
                        [showAdd]="true"
                        [addText]="'Add New'"
                        [customAddText]="'Select'"
                        [customActionComponent]="this"
                        [showEdit]="true"
                        [showDelete]="true"
                    ></action-toolbar-buttons>
                    @if (canEdit) {
                        <button
                            type="button"
                            class="btn btn-sm btn-secondary ml-2"
                            (click)="archiveRock()"
                            [disabled]="!grid.hasItemSelected"
                            title="Archive the selected ROCK"
                        >
                            <i class="fas fa-archive"></i> Archive
                        </button>
                    }
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                    <button
                        type="button"
                        style="margin-left: auto"
                        class="btn btn-sm btn-secondary ml-2"
                        (click)="toggleShowArchived()"
                        [class.btn-primary]="showArchived()"
                        title="Toggle showing archived ROCKs"
                    >
                        <i class="fas" [class.fa-eye]="!showArchived()" [class.fa-eye-slash]="showArchived()"></i>
                        {{ showArchived() ? 'Hide Archived' : 'Show Archived' }}
                    </button>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="mainGrid"
                    #mainGrid
                    appAutoSize
                    [minHeight]="70"
                    (initialized)="grid.initialize(mainGrid)"
                    [itemFormatter]="gridItemFormatter"
                    (destroy)="grid.destroy()"
                    [itemsSource]="grid.view"
                    (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                    (beginningEdit)="beginningEdit()"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column
                        [header]="'Who'"
                        [binding]="'userId'"
                        [dataMap]="allUserMap"
                        [width]="75"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Due'" [binding]="'dueDate'" [width]="125" [editor]="inputDate"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'To-Do'" [binding]="'name'" [width]="'*'" [minWidth]="200"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Status'" [binding]="'status'" [dataMap]="statusMap" [width]="130"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Type'"
                        [binding]="'type'"
                        [dataMap]="typeMap"
                        [width]="130"
                        [visible]="!isActiveMeeting()"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Done'"
                        [binding]="'doneDate'"
                        [width]="125"
                        [editor]="inputDate"
                        [isRequired]="false"
                    ></wj-flex-grid-column>
                </wj-flex-grid>
                <wj-input-date #inputDate [isRequired]="false"></wj-input-date>
            </div>
        </div>
    </div>

    <div class="col-lg-5" appAutoSize [minHeight]="100">
        <div [style.display]="grid.selectedItem ? 'flex' : 'none !important'" class="h-100 d-flex flex-column">
            <div style="height: 200px">
                <h5 class="text-truncate text-muted" style="margin-bottom: 15px">Details for "{{ grid.selectedItem?.name }}"</h5>
                <div style="height: calc(200px - 36px); overflow: hidden">
                    <quill-view
                        style="display: block; height: 100%"
                        [content]="grid.selectedItem?.details ?? 'No Details'"
                        theme="snow"
                    ></quill-view>
                </div>
            </div>

            <div class="flex-grow-1" style="margin-top: 20px">
                <div class="row action-toolbar">
                    <div class="col-12">
                        <h5 class="text-truncate text-muted" style="margin-bottom: 12px">Milestones for "{{ grid.selectedItem?.name }}"</h5>
                        <form class="form-inline">
                            <action-toolbar-count [grid]="milestonesGrid"></action-toolbar-count>
                            <action-toolbar-buttons
                                [grid]="milestonesGrid"
                                [canEdit]="canEdit"
                                [showAdd]="true"
                                [showEdit]="true"
                                [showDelete]="true"
                            ></action-toolbar-buttons>
                            <action-toolbar-search name="search" [(ngModel)]="milestonesGrid.filter"></action-toolbar-search>
                        </form>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12">
                        <wj-flex-grid
                            id="gridMilestones"
                            #gridMilestones
                            appAutoSize
                            [minHeight]="70"
                            (initialized)="milestonesGrid.initialize(gridMilestones)"
                            [itemFormatter]="gridItemFormatter"
                            (destroy)="milestonesGrid.destroy()"
                            [itemsSource]="milestonesGrid.view"
                            (cellEditEnded)="cellEditEnded(gridMilestones, $event)"
                            (beginningEdit)="beginningEdit()"
                        >
                            <wj-flex-grid-filter></wj-flex-grid-filter>
                            <wj-flex-grid-column
                                [header]="'Who'"
                                [binding]="'userId'"
                                [dataMap]="allUserMap"
                                [width]="75"
                                [isReadOnly]="true"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column [header]="'Due'" [binding]="'dueDate'" [width]="125"></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'Milestone'"
                                [binding]="'name'"
                                [width]="'*'"
                                [minWidth]="200"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'Done'"
                                [binding]="'doneDate'"
                                [width]="125"
                                [editor]="inputDateMilestones"
                                [isRequired]="false"
                            ></wj-flex-grid-column>
                        </wj-flex-grid>
                        <wj-input-date #inputDateMilestones [isRequired]="false"></wj-input-date>
                    </div>
                </div>
            </div>
        </div>

        <div
            [style.display]="!grid.selectedItem ? 'flex' : 'none !important'"
            class="d-flex align-items-center justify-content-center h-100"
            [style.visibility]="
                isInitialLoading
                    ? 'hidden !important
            '
                    : 'visible !important
            '
            "
        >
            <div class="text-center">
                <div class="mb-3">
                    <i class="fas fa-hand-pointer fa-3x text-muted"></i>
                </div>
                <h5 class="text-muted mb-2">No Rock Selected</h5>
                <p class="text-muted mb-0">Select a rock from the list to view its details and milestones</p>
            </div>
        </div>
    </div>
</div>
